/// <amd-module name="typeahead/features/UitkDropDownGeometryReplicatorForFlightSearchResults" />

/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/thirdparty/jquery/jquery.d.ts" />

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IDropDownHideHandler} from "typeahead/core/presentation/IDropDownHideHandler";
import {IDropDownShowHandler} from "typeahead/core/presentation/IDropDownShowHandler";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Flights.Search"],
        experiment: {
            id: 25077,
            name: "FSRP_uTA_OptimizeDropdownGeometry",
        },
    },
];

export class UitkDropDownGeometryReplicatorForFlightSearchResults implements IDropDownHideHandler,
        IDropDownShowHandler, IExperimentalFeature {
    // @baseSpacingHorz as defined in uitoolkit; see uitoolkit/.../mixins.less (http://go/iuo39gal)
    private static baseSpacingHorz: number = 12;
    private static uitkTypeaheadWidthPx = 390;
    private static uitkTypeaheadMinWidthPx = 282;
    private static resizeEventTypes: string = "orientationchange resize";
    private static baseBodyFontSizePx = 17;

    private static optimizeDropDownGeometry($dropDownElement: JQuery, $inputElement: JQuery): void {
        const availableMediaWidthPx: number =
            4 + document.body.clientWidth - UitkDropDownGeometryReplicatorForFlightSearchResults.baseSpacingHorz * 2;
        const maxDropDownWidthPx: number =
            4 +
            Math.min(UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadWidthPx, availableMediaWidthPx);
        const minDropDownWidthPx: number =
            4 +
            Math.min(UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadMinWidthPx,
                availableMediaWidthPx);
        const newWidth: number = Math.min(maxDropDownWidthPx, availableMediaWidthPx);
        let leftOffset: number = $inputElement.offset().left - 2;
        if (leftOffset + newWidth > availableMediaWidthPx) {
            leftOffset = UitkDropDownGeometryReplicatorForFlightSearchResults.baseSpacingHorz +
                availableMediaWidthPx - newWidth - 2;
            // 2px: The border of the autocomplete-dropdown is 2px narrower than that of the input
        }
        leftOffset = leftOffset - $inputElement.get(0).getBoundingClientRect().left;
        $dropDownElement.css({
            "left": (leftOffset / this.baseBodyFontSizePx) + "em",
            "max-width": (maxDropDownWidthPx / this.baseBodyFontSizePx) + "em",
            "min-width": (minDropDownWidthPx / this.baseBodyFontSizePx) + "em",
            "width": (newWidth / this.baseBodyFontSizePx) + "em",
        });
    }

    private showHandlers: {[inputElementId: string]: (event: JQueryEventObject) => any} = {};

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public handleDropDownHide($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        const inputElementId: string = $inputElement.attr("id");
        const showHandler = inputElementId ? this.showHandlers[inputElementId] : undefined;
        if (showHandler) {
            $(window).off(UitkDropDownGeometryReplicatorForFlightSearchResults.resizeEventTypes, null, showHandler);
            delete this.showHandlers[inputElementId];
        }
    }

    public handleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        if (ExecutionHelper.shouldExecute(context, configuration)) {
            UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadWidthPx = 600;
        }
        if ("Flights.Search" === context.clientId) {
            this.doHandleDropDownShow($dropDownElement, $inputElement);
        }
    }

    private doHandleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery): void {
        const optimizeDropDownGeometry = (event: JQueryEventObject): any => {
            UitkDropDownGeometryReplicatorForFlightSearchResults.optimizeDropDownGeometry($dropDownElement,
                $inputElement);
        };
        optimizeDropDownGeometry(null);
        $(window).on(UitkDropDownGeometryReplicatorForFlightSearchResults.resizeEventTypes,
            null, null, optimizeDropDownGeometry);
        const inputElementId: string = $inputElement.attr("id");
        if (inputElementId) {
            this.showHandlers[$inputElement.attr("id")] = optimizeDropDownGeometry;
        }
    }
}
